import React from 'react';
import { ModuleProps } from 'types';
import { useLocation } from 'react-router-dom';
import { parseQueryParams } from 'utilities/query-params-util';
import ClassroomCertificatesContainer from 'components/PrintScreenModule/Certificates/components/ClassroomCertificatesContainer';
import StudentCertificatesContainer from 'components/PrintScreenModule/Certificates/components/StudentCertificatesContainer';

const LoginCardContainer: React.FC<ModuleProps> = () => {
  const location = useLocation();
  const params = parseQueryParams(location.search);

  return (
    <div>
      {params?.classroomId && params?.certificateType && (
        <ClassroomCertificatesContainer
          classroomId={Number(params.classroomId)}
          certificateType={`${params?.certificateType}`}
        />
      )}
      {params?.studentId && params?.certificateType && (
        <StudentCertificatesContainer
          studentId={Number(params.studentId)}
          certificateType={`${params?.certificateType}`}
        />
      )}
    </div>
  );
};

export default LoginCardContainer;
